var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "div",
            {
              staticClass:
                "w-100 mx-3 d-flex justify-content-between align-items-center"
            },
            [
              _c("h4", { staticClass: "mb-0" }, [_vm._v("LEAVE CALENDAR")]),
              _vm._v(" "),
              !_vm.isPickDate
                ? _c(
                    "span",
                    {
                      staticClass: "cursor-pointer",
                      staticStyle: { "font-size": "12px" },
                      on: { click: _vm.pickDate }
                    },
                    [
                      _c("i", { staticClass: "fa fa-calendar" }),
                      _vm._v(
                        "\n        " + _vm._s(_vm.formattedDate) + "\n      "
                      )
                    ]
                  )
                : _c("j-datepicker", {
                    attrs: { "auto-open": true, format: "MMM dd, yyyy" },
                    on: { selected: _vm.changedDate },
                    model: {
                      value: _vm.selectedDate,
                      callback: function($$v) {
                        _vm.selectedDate = $$v
                      },
                      expression: "selectedDate"
                    }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticStyle: {
                "min-height": "300px",
                "max-height": "300px",
                "overflow-x": "auto"
              },
              attrs: { cols: "12" }
            },
            [
              _vm.leave_employee_list.length <= 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-center",
                      staticStyle: { height: "250px" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column align-items-center no-leave"
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/icon/info.png"),
                              width: "60",
                              height: "60"
                            }
                          }),
                          _vm._v(" "),
                          _c("h6", [_vm._v("Data is empty")]),
                          _vm._v(" "),
                          _c("h6", [_vm._v("There is no employee on leave")])
                        ]
                      )
                    ]
                  )
                : _vm._l(_vm.leave_employee_list, function(item) {
                    return _c("div", { key: item.id, staticClass: "mt-3" }, [
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("div", {
                          staticClass: "ava-profile m__r--10",
                          staticStyle: { flex: "none !important" },
                          style:
                            "background-image: url('" +
                            (item.photo_url
                              ? item.photo_url
                              : "https://corp.jojonomic.com/assets/img/user3.png") +
                            "');"
                        }),
                        _vm._v(" "),
                        _c("span", { staticStyle: { "font-size": "10px" } }, [
                          _c(
                            "strong",
                            { staticStyle: { "font-size": "14px" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.employee_name) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n            " +
                              _vm._s(item.type_name) +
                              "\n          "
                          )
                        ])
                      ])
                    ])
                  })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f50035f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f50035f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/widget-card/jLeaveAllEmployeeWidget.vue
// module id = null
// module chunks = 